module.exports = __webpack_public_path__ + "static/media/siddharth-iphone.4cb9ef9a.jpg";